import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=6a614d4a&scoped=true&"
import script from "./Client.vue?vue&type=script&lang=js&"
export * from "./Client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a614d4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/wnytoys/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a614d4a')) {
      api.createRecord('6a614d4a', component.options)
    } else {
      api.reload('6a614d4a', component.options)
    }
    module.hot.accept("./Client.vue?vue&type=template&id=6a614d4a&scoped=true&", function () {
      api.rerender('6a614d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/app/components/client/Client.vue"
export default component.exports